// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8943 ? "8627a13e" : chunkId) + "." + {"8546":"cf60070cd3eb331d","8943":"5aa378fcafd678ba"}[chunkId] + ".js";
};